import React from "react";
import {
BrowserRouter as Router,
Routes,
Route,
Navigate,
useLocation
} from "react-router-dom";

/* =========================
SCROLL TOP
========================= */

import ScrollToTop from "./Client/Pages/ScrollToTop";


/* =========================
CLIENT IMPORTS
========================= */

import Navbar from "./Client/Layouts/Navbar";
import Footer from "./Client/Layouts/Footer";

import Home from "./Client/Pages/Home";
import AboutUs from "./Client/Pages/About";
import Membership from "./Client/Pages/Membership";
import Loan from "./Client/Pages/Loan";
import Insurance from "./Client/Pages/Insurance";
import Join from "./Client/Pages/Join";
import Gallery from "./Client/Pages/Gallery";
import Services from "./Client/Pages/Service";


/* =========================
ADMIN IMPORTS
========================= */

import Sidebar from "./dhanlaxmiMyAdmin/Layouts/Sidebar";
import Header from "./dhanlaxmiMyAdmin/Layouts/Header";

import Dashboard from "./dhanlaxmiMyAdmin/Pages/Dashboard";
import Aboutus from "./dhanlaxmiMyAdmin/Pages/Aboutus";
import Contactus from "./dhanlaxmiMyAdmin/Pages/Contactus";
import Contactinfo from "./dhanlaxmiMyAdmin/Pages/Contactinfo";
import Team from "./dhanlaxmiMyAdmin/Pages/Team";
import ServicesAdmin from "./dhanlaxmiMyAdmin/Pages/Services";
import Activities from "./dhanlaxmiMyAdmin/Pages/Activites";
import Holidays from "./dhanlaxmiMyAdmin/Pages/Holiday";
import News from "./dhanlaxmiMyAdmin/Pages/News";
import Logout from "./dhanlaxmiMyAdmin/Pages/Logout";
import Login from "./dhanlaxmiMyAdmin/Pages/Login";
import ForgotPassword from "./dhanlaxmiMyAdmin/Pages/ForgotPassword";
import PrivateRoute from "./dhanlaxmiMyAdmin/Pages/PrivateRoute";


/* =========================
CLIENT CSS
========================= */

import "./Client/Styles/Navbar.css";
import "./Client/Styles/Footer.css";
import "./Client/Styles/Home.css";
import "./Client/Styles/Aboutus.css";
import "./Client/Styles/MemberShip.css";
import "./Client/Styles/Loan.css";
import "./Client/Styles/insourance.css";
import "./Client/Styles/Join.css";
import "./Client/Styles/Gallery.css";
import "./Client/Styles/Services.css";
import "./Client/Styles/themes.css";


/* =========================
ADMIN CSS
========================= */

import "./dhanlaxmiMyAdmin/Styles/themes.css";
import "./dhanlaxmiMyAdmin/Styles/Sidebar.css";
import "./dhanlaxmiMyAdmin/Styles/Header.css";
import "./dhanlaxmiMyAdmin/Styles/Aboutus.css";
import "./dhanlaxmiMyAdmin/Styles/Contactus.css";
import "./dhanlaxmiMyAdmin/Styles/contactinfo.css";
import "./dhanlaxmiMyAdmin/Styles/team.css";
import "./dhanlaxmiMyAdmin/Styles/Services.css";
import "./dhanlaxmiMyAdmin/Styles/Dashboard.css";
import "./dhanlaxmiMyAdmin/Styles/Activities.css";
import "./dhanlaxmiMyAdmin/Styles/Logout.css";
import "./dhanlaxmiMyAdmin/Styles/Login.css";
import "./dhanlaxmiMyAdmin/Styles/Holiday.css";
import "./dhanlaxmiMyAdmin/Styles/news.css";
import "./dhanlaxmiMyAdmin/Styles/forgotPassword.css";


/* =========================
LAYOUT COMPONENT
========================= */

function Layout() {

const location = useLocation();

// Check admin routes
const isAdminRoute = location.pathname.startsWith("/dhanlaxmiMyAdmin");

// Hide sidebar/header/content on login pages
const hideAdminLayout =
location.pathname === "/dhanlaxmiMyAdmin/login" ||
location.pathname === "/dhanlaxmiMyAdmin/forgot-password";


return (

<div>

<ScrollToTop />


{/* =========================
CLIENT NAVBAR
========================= */}

{!isAdminRoute && <Navbar />}


{/* =========================
ADMIN LAYOUT
========================= */}

<div className={isAdminRoute ? "admin-layout" : "client-layout"}>

{isAdminRoute && !hideAdminLayout && <Sidebar />}

<div className={isAdminRoute ? "main" : ""}>

{isAdminRoute && !hideAdminLayout && <Header />}


{/* Content Wrapper */}
<div className={isAdminRoute && !hideAdminLayout ? "content" : ""}>

<Routes>

{/* =========================
CLIENT ROUTES
========================= */}

<Route path="/" element={<Home />} />
<Route path="/home" element={<Home />} />
<Route path="/about" element={<AboutUs />} />
<Route path="/membership" element={<Membership />} />
<Route path="/loans" element={<Loan />} />
<Route path="/insurance" element={<Insurance />} />
<Route path="/join" element={<Join />} />
<Route path="/gallery" element={<Gallery />} />
<Route path="/service" element={<Services />} />


{/* =========================
ADMIN PUBLIC ROUTES
========================= */}

<Route caseSensitive path="/dhanlaxmiMyAdmin" element={<Navigate to="/dhanlaxmiMyAdmin/login" />} />

<Route caseSensitive path="/dhanlaxmiMyAdmin/login" element={<Login />} />

<Route caseSensitive
path="/dhanlaxmiMyAdmin/forgot-password"
element={<ForgotPassword />}
/>


{/* =========================
ADMIN PROTECTED ROUTES
========================= */}

<Route caseSensitive
path="/dhanlaxmiMyAdmin/dashboard"
element={
<PrivateRoute>
<Dashboard />
</PrivateRoute>
}
/>

<Route caseSensitive
path="/dhanlaxmiMyAdmin/about"
element={
<PrivateRoute>
<Aboutus />
</PrivateRoute>
}
/>

<Route caseSensitive
path="/dhanlaxmiMyAdmin/contactus"
element={
<PrivateRoute>
<Contactus />
</PrivateRoute>
}
/>

<Route caseSensitive
path="/dhanlaxmiMyAdmin/contactinfo"
element={
<PrivateRoute>
<Contactinfo />
</PrivateRoute>
}
/>

<Route caseSensitive
path="/dhanlaxmiMyAdmin/team"
element={
<PrivateRoute>
<Team />
</PrivateRoute>
}
/>

<Route caseSensitive
path="/dhanlaxmiMyAdmin/services"
element={
<PrivateRoute>
<ServicesAdmin />
</PrivateRoute>
}
/>

<Route caseSensitive
path="/dhanlaxmiMyAdmin/activities"
element={
<PrivateRoute>
<Activities />
</PrivateRoute>
}
/>

<Route caseSensitive
path="/dhanlaxmiMyAdmin/holiday"
element={
<PrivateRoute>
<Holidays />
</PrivateRoute>
}
/>

<Route caseSensitive
path="/dhanlaxmiMyAdmin/news"
element={
<PrivateRoute>
<News />
</PrivateRoute>
}
/>

<Route caseSensitive
path="/dhanlaxmiMyAdmin/logout"
element={
<PrivateRoute>
<Logout />
</PrivateRoute>
}
/>

</Routes>

</div>

</div>

</div>


{/* =========================
CLIENT FOOTER
========================= */}

{!isAdminRoute && <Footer />}

</div>

);

}


/* =========================
APP MAIN
========================= */

export default function App() {

return (

<Router>
<Layout />
</Router>

);

}